import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { useParams } from "react-router";
import {
  NoDataFoundTable,
  SpinerDataLoader,
} from "../../../NoDataFoundTable/NoDataFoundTable";

const Activity = ({ onMouseDown1, tableRef1, activity }) => {
  const [loader, setLoader] = useState(false);
  const ref = useParams();
  return (
    <>
      {loader ? (
        <SpinerDataLoader />
      ) : activity?.length === 0 ? (
        <NoDataFoundTable MSG="Activity not found" />
      ) : (
        <Table
          id="resizable-table"
          striped
          hover
          className="m-0 custom-table"
          ref={tableRef1}
        >
          <thead>
            <tr>
              <th
                onMouseDown1={(e) => onMouseDown1(e, 0)}
                style={{ width: 50 }}
                className="text-center"
              >
                Sr.
              </th>
              <th onMouseDown1={(e) => onMouseDown1(e, 1)}>Status</th>
              <th onMouseDown1={(e) => onMouseDown1(e, 2)}>Type</th>
              <th onMouseDown1={(e) => onMouseDown1(e, 3)}>Activities</th>
              <th onMouseDown1={(e) => onMouseDown1(e, 4)}>Categories</th>
              <th onMouseDown1={(e) => onMouseDown1(e, 5)}>Activity By</th>
              <th onMouseDown1={(e) => onMouseDown1(e, 6)}>Activity Date</th>
              <th onMouseDown1={(e) => onMouseDown1(e, 7)}>Activity Time</th>
            </tr>
          </thead>
          <tbody ref={ref}>
            <tr>
              <td className="text-center">1</td>
              <td>dsfgh</td>
              <td>dsfgh</td>
              <td>dsfgh</td>
              <td>dsfgh</td>
              <td>dsfgh</td>
              <td>dsfgh</td>
              <td>dsfgh</td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  );
};

export default Activity;
